import { ShieldAlert } from 'lucide-react';
import Button from '../ui/Button';
import { useNavigate, useLocation } from 'react-router-dom';

const ForbiddenPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | undefined)?.from;

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center space-y-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
        <ShieldAlert className="h-8 w-8 text-destructive" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight">Access Denied</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          You don't have permission to access this page. Please contact the system administrator to request appropriate permissions if you believe this is an error.
        </p>
        {from && (
          <p className="text-xs text-muted-foreground">Requested page: {from}</p>
        )}
      </div>
      <div className="flex items-center gap-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default ForbiddenPage;

